export default __webpack_public_path__ + "static/media/src_img_12.1467461e.png";